<div class="resource-card" (click)="navigateToResource()">
  <div class="resource-card__left">
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="66" viewBox="0 0 54 66">
      <path
        d="M36.78,48c-6.14-4.75-17.78-15.87-17.78-32v-1h-1c-1.66,0-3-1.34-3-3s1.34-3,3-3h36v6h-29v1c0,14.9,12.55,25.2,17,28.38,2.6-1.86,7.98-6.17,12-12.41v9.82c-2.45,2.65-4.88,4.73-6.78,6.21,1.9,1.47,4.33,3.55,6.78,6.21v9.82c-4.01-6.24-9.39-10.54-12-12.41-2.87,2.05-9.11,7.08-13.18,14.38h-6.75c3.88-8.64,10.55-14.78,14.72-18ZM52,24c0-1.66-1.34-3-3-3h-14c-1.66,0-3,1.34-3,3s1.34,3,3,3h14c1.66,0,3-1.34,3-3ZM42.5,37c1.66,0,3-1.34,3-3s-1.34-3-3-3h-1c-1.66,0-3,1.34-3,3s1.34,3,3,3h1Z" />
    </svg>
  </div>
  <div class="resource-card__right">
    <div class="resource-card__right__header">
      <div class="resource-card__right__header__title">
        {{'user.careerplans.complementary.title' | translate: { hours: resource.hoursToComplete } }}
      </div>
      <div class="resource-card__right__header__subtitle">
        <opac-icon icon="hourglass"></opac-icon>
        <span class="resource-type">{{resource.hoursToComplete}}</span>
      </div>
    </div>
    <div class="resource-card__right__body">
      <div>
        <div class="resource-card__right__body__left" *ngIf="resource?.progress">
          <div class="resource-card__right__body__left__progress" *ngIf="resource?.progress < 100">
            <span class="pctg">{{ resource?.completedTime }}</span>
            <opac-progress-bar [progress]="resource?.progress" progressText="%"></opac-progress-bar>
          </div>

          <div class="resource-card__right__body__left__status" *ngIf="resource?.progress === 100">
            <span class="status-label">{{ completionLabel }}</span>
            <span
              class="career-plan-resource-status"
              [ngClass]="{
                'career-plan-resource-status--completed': resource?.progress === 100,
                'career-plan-resource-status--checking': resource?.progress < 100
              }">
            </span>
          </div>
        </div>
      </div>

      <opac-button>
        <opac-icon slot="only-icon" icon="navigate_next"></opac-icon>
      </opac-button>
    </div>
  </div>
</div>
